import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PainSection } from './components/PainSection';
import { SystemRevealSection } from './components/SystemRevealSection';
import { VolumesSection } from './components/VolumesSection';
import { MidPageCta } from './components/MidPageCta';
import { IncludesSection } from './components/IncludesSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { CostSection } from './components/CostSection';
import { FinalOfferSection } from './components/FinalOfferSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { PurchaseToast } from './components/PurchaseToast';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-charcoal-950 font-sans text-body" data-id="element-0" data-mp="3mlj6io8cn0zw">
      <Hero data-id="element-1" data-mp="3mjq3rk0ux0x6" />

      <main data-id="element-2" data-mp="3mj6hjr46bqdc">
        <TestimonialsSection data-id="element-3" data-mp="3rc9co3oln7vn" />
        <PainSection data-id="element-4" data-mp="3rbzpsoyupgu6" />
        <SystemRevealSection data-id="element-5" data-mp="3rcsyvwla8ifh" />
        <VolumesSection data-id="element-6" data-mp="3relv0hy9rk98" />
        <MidPageCta data-id="element-7" data-mp="6hrlipoilfp" />
        <IncludesSection data-id="element-8" data-mp="4wx1t3d72hu" />
        <BonusesSection data-id="element-9" data-mp="56n1goet9nj" />
        <OfferSection data-id="element-10" data-mp="2zl39tfhhuw2o" />
        <TestimonialsSection variant="compact" id="proof-2" data-id="element-11" data-mp="2zllduyaeeel5" />
        <GuaranteeSection data-id="element-12" data-mp="2zn66ujh2dpgw" />
        <FaqSection data-id="element-13" data-mp="33mf0zpg0npcz" />
        <CostSection data-id="element-14" data-mp="33nq6btp41567" />
        <FinalOfferSection data-id="element-15" data-mp="33n6y54p9hv5d" />
      </main>

      <Footer data-id="element-16" data-mp="38lrpsfqg76i7" />
      <StickyCta data-id="element-17" data-mp="38l8gfnev5qfs" />
      <PurchaseToast data-id="element-18" data-mp="38kqb81a841vq" />
    </div>;
}